export default "__VITE_ASSET__Cq$WzCp9__"